<template>
  <div class="myFont">
    <!-- 活动标题 -->
    <div v-wechat-title="'新仙剑丨师徒系统'"></div>
    <div class="page">
      <div class="content">
        <div class="user_info_box" v-if="this.userInfo.role_id">
          <div class="user_name">{{this.userInfo.role_name}}</div>
          <div class="change_btn" @click="changeOsPopup(true)">切换</div>
        </div>
        <div class="login_btn" v-else @click="changeLoginPopup(true)"></div>
        <div :class="'title title_' + typeName"></div>
        <div :class="'text text_' + typeName"></div>
        <div :class="'tip tip_' + typeName"></div>

        <!-- <p class="test_btn"
          @touchstart.stop="onTouchStart()"
          @touchend.stop="onTouchEnd()">
          132132---{{this.fingerprintStatus}}
        </p> -->

        <div class="role">
          <div :class="'role-' + typeName + '-' + info.sex"></div>
          <div class="info">
            <div class="capability"><span>{{this.info.faq}}</span></div>
            <div class="detail">
              <div class="grade">{{this.info.player_lv}}</div>
              <div class="name">{{this.info.role_name}}</div>
              <div :class="'sex sex-' + info.sex"></div>
            </div>
            <div class="area_box">{{this.info.server_name}}</div>
          </div>
        </div>

        <div class="fingerprint" @click="onClickFingerprint()"></div>
      </div>
      
      <!-- 商品兑换-弹窗 -->
      <div class="popup_wrap result-wrap" v-show="resultShow" @click="resultShow = false">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
          <div :class="'popup-wrap-box ' + typeName + '-result-box'" v-show="resultShow" @click.stop="">
            <div class="btn" @click="jumpActivePage()"></div>
          </div>
        </transition>
      </div>
    </div>
    <!-- 登陆模块 -->
    <Login v-if="isShowLogin"
      v-on:channelCallback="selectCallback"
      :gameName="gameName"
      :loginTypes="loginTypes"
      downloadUrl="https://static.qcplay.com/tideng/official/"
      channelTips="UID可在游戏中—设置—UID查看"></Login>
    <Os
      v-if="isShowOs"
      v-on:selectCallback="selectCallback"
      v-on:logoutCallback="osCancell"
      :gameName="gameName"></Os>

  </div>

</template>
<script>
import { Toast } from 'mint-ui';
import Os from '@/components/os';
import Login from '@/components/login';
import { mapState, mapMutations, mapActions } from 'vuex';
import { analysisParams, buriedLogger, getRandomString } from '@/utils/utils';
import { onGetInitDataAPI, onRecruitAPI, getUserInfoByCodeId } from '../api.js';

export default {
  name: 'mentoring_invitationLetter',
  components: {
    Login,
    Os
  },
  data () {
    return {
      gameName: 'hjwq',
      logger: null,
      loginTypes: ['sms', 'password'],

      type: 0,  // 1: 拜师  2: 收徒
      typeName: '',
      resultShow: false,
      code: '',
      info: {},
      user_id: '',
      times: [],
      fingerprintStatus: 0 // 指纹状态
    };
  },
  created () {
    const params = analysisParams(window.location.href);
    let { type, user_id, code } = params;
    type = Number(type);

    if ([1,2].includes(type) && code && user_id) {
      this.type = type;
      this.user_id = user_id;
      this.code = code;
      this.typeName = {1: 'prentice', 2: 'master'}[type];
    } else {
      this.onToast('无效链接');
    }
    this.getLoginContainer();
    // 埋点
    const bl = buriedLogger('hjwq', 'mentoring_invitation_page');
    this.logger = bl;
  },
  mounted () {},
  computed: {
    ...mapState([
      'userInfo',
      'activeInfo',
      'isShowLogin',
      'isShowOs'
    ])
  },
  methods: {
    // 长按 - 点击按钮
    onTouchStart () {
      const times = [];
      times[0] = setTimeout(() => {
        this.fingerprintStatus = 1;
      }, 1000);
      times[1] = setTimeout(() => {
        this.fingerprintStatus = 2;
        // TODO: 发起api请求
      }, 2000);
      this.times = times;
    },
    // 长按 - 点击后移动
    onTouchMove () {
      if (this.times.length) {
        this.times.forEach(timeId => clearTimeout(timeId));
        this.times = [];
        this.fingerprintStatus = 0;
      }
    },
    // 长按 - 释放按钮
    onTouchEnd () {
      if (this.fingerprintStatus === 2) {
        this.times.forEach(timeId => clearTimeout(timeId));
        this.times = [];
        this.fingerprintStatus = 0;
      } else {
        this.onToast('请长按指纹2秒')
      }
    },
    onClickFingerprint () {
      if (!this.userInfo.role_id) {
        this.onToast('请先登录');
        this.changeLoginPopup(true);
        return false;
      }
      if ([1,2].includes(this.type) && this.code) {
        onRecruitAPI({
          ...this.info,
          status: this.type,
          code: this.code,
        }).then(response => {
          this.resultShow = true;
          this.onToast(response.message);
        });
      } else {
        this.onToast('无效页面链接');
      }
      const name = { 1: '拜师',  2: '收徒'}[this.type];
      this.logger.sum(`确认${name}`);
    },
    // 初始化/更新用户活动信息
    getLoginContainer () {
      onGetInitDataAPI().then(response => {
        this.onInitDataCallback(response);
        getUserInfoByCodeId({ id: this.user_id, code: this.code }).then((rsp) => {
          this.info = rsp.data.user_info;
        });
        // this.preloadingShow = false;
      });
    },
    selectCallback () {
      this.getLoginContainer();
    },
    osCancell () {
    },
    // 进入活动主页
    jumpActivePage () {
      const { protocol, host } = window.location;
      const link = `${protocol}//${host}/hjwq/mentoring/enter${getRandomString()}`;
      this.logger.sum('前往蜀山师门');
      setTimeout(() => {
        window.location.href = link;
      }, 100);
    },
    // TAG: 其他简易封装的方法
    onToast (config) {
      const curConfig = {
        duration: 1000,
        className: 'toasts rotate'
      };
      if (!config) {
        console.error('缺少config参数');
        return false;
      }
      if (typeof config === 'string') {
        curConfig.message = config;
      }
      Toast(curConfig);
    },
    ...mapMutations([
      'setUserInfo',
      'setInitUserInfo',
      'confirmLogout',
      'setInitActiveInfo',
      'changeLoginPopup',
      'changeOsPopup'
    ]),
    ...mapActions([
      'onInitDataCallback'
    ])
  }
};
</script>

<style lang="less">
  @import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/hjwq/mentoring/invitationLetter/index.vue